import React, {useState, useEffect} from "react";
import { useAuth } from "../../Context/Auth";
import { ProfileCardContent, ProfileContentSubTitle, ProfileContentTitle } from "./style";
import Card from "../../Components/Miscellaneous/Card";
import OrderService from "../../Utils/API/orders";
import { Button, Input, Loader } from "../Login/style";
import Layout from "../../Components/Layout";
export default function Profile() {

    const { user } = useAuth();
    const [total, setTotal] = useState(null);
    const [spent, setSpent] = useState(null);
    useEffect(() => {
        OrderService.getTotalOrders().then(response => {
            setTotal(
                response
            );
        }).catch(error => {
            console.error(error);
        });
        OrderService.getTotalOrderAmount().then(response => {
            setSpent(response);
        }
        ).catch(error => {
            console.error(error);
        });

    }
    , []);

    return (
        <div>
            <ProfileContentTitle>
            Hola, {user?.Name + ' ' + user?.Surname}
            </ProfileContentTitle>
            <ProfileCardContent>
            <Card xs loading={total === null ? true : false}>
                <span style={{fontSize: '1rem', textAlign: 'center'}}>Pedidos Totales</span>
                <span style={{fontSize: '2rem', textAlign: 'center', fontWeight:'bold'}}>{total}</span>
            </Card>
            <Card xs loading={spent === null ? true : false}>
                <span style={{fontSize: '1rem', textAlign: 'center'}}>Gasto Total</span>
                <span style={{fontSize: '1.5rem',lineBreak:'anywhere', textAlign: 'center', fontWeight:'bold'}}>{spent}€</span>
            </Card>
            <Card xs>
                <span style={{fontSize: '1rem', textAlign: 'center'}}>Pedidos Enviados</span>
                <span style={{fontSize: '2rem', textAlign: 'center', fontWeight:'bold'}}>0</span>
            </Card>
            <Card xs>
                <span style={{fontSize: '1rem', textAlign: 'center'}}>Facturas Pendientes</span>
                <span style={{fontSize: '2rem', textAlign: 'center', fontWeight:'bold'}}>0</span>
            </Card>
            </ProfileCardContent>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '2rem',
                    gap: '1rem'
                }}
            >
                <ProfileContentSubTitle>
                    Cambiar Contraseña
                </ProfileContentSubTitle>
                <Input type="password" placeholder="Contraseña antigua"/>
                <Input type="password" placeholder="Contraseña nueva"/>
                <Button>
                    Cambiar Contraseña
                </Button>
            </div>
        </div>
    )
}
